import { render, staticRenderFns } from "./CateNav.vue?vue&type=template&id=90ef0c5e&scoped=true&"
import script from "./CateNav.vue?vue&type=script&lang=js&"
export * from "./CateNav.vue?vue&type=script&lang=js&"
import style0 from "./CateNav.vue?vue&type=style&index=0&id=90ef0c5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ef0c5e",
  null
  
)

export default component.exports